import { useApi } from "@soft-db/monitoring-api-client";
import { useQueryEnabled, useScopedQuery } from "./query";

// -- Keys --
export const externalRecipientKeys = {
	root: ["externalRecipients"] as const,

	byId: (id: string) => [...externalRecipientKeys.root, id] as const,
};

export function useExternalRecipient(id: MaybeRefOrGetter<string>) {
	const api = useApi().externalRecipients();

	const { data: externalRecipient, ...rest } = useScopedQuery({
		key: () => externalRecipientKeys.byId(toValue(id)),
		query: () => api.fetchById(toValue(id)),
		enabled: useQueryEnabled(id),
	});

	return {
		externalRecipient,
		...rest,
	};
}
